/* @ngInject */
function dateShortFilter ($filter, $translate) {
  return function (date) {
    if (!date) {
      return $translate.instant('noDate')
    }
    const newDate = moment(date)
    return newDate.format('DD MMM')
  }
}

export { dateShortFilter }
